/*** Set Detail Page Banner Start ***/
function setDetailPageBanner(diamond_type){
  if(diamond_type == ''){
    $(".tps-color-diamond-detail-banner-section").hide();
  }else{
    $(".tps-white-diamond-detail-banner-section").hide();
  }
}
/*** Set Detail Page Banner End ***/

/*** Set Back To Search URL Start ***/ 
function changeBreadcrumUrl(diamond_type,diamondData) {
  // if(diamond_type == 'white'){
  //   if(diamondData.fancyColor == ''){
  //     $("#tps_back_to_search").attr("href", tps_config.urls.loose_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_diamond);
  //   }else{
  //     $("#tps_back_to_search").attr("href", tps_config.urls.loose_color_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_color_diamond);
  //   }    
  // }else if(diamond_type == 'lab'){
  //   if(diamondData.fancyColor == ''){
  //     $("#tps_back_to_search").attr("href", tps_config.urls.lab_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_diamond);
  //   }else{
  //     $("#tps_back_to_search").attr("href", tps_config.urls.lab_color_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_color_diamond);
  //   }
  // } 

  if(diamond_type == 'natural-fancy'){
      $("#tps_back_to_search").attr("href", tps_config.urls.loose_color_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_color_diamond); 
  }else if(diamond_type == 'natural-white'){
      $("#tps_back_to_search").attr("href", tps_config.urls.loose_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_diamond);
  }else if(diamond_type == 'lab-white'){
      $("#tps_back_to_search").attr("href", tps_config.urls.lab_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_diamond);
  }else if(diamond_type == "lab-fancy"){
    $("#tps_back_to_search").attr("href", tps_config.urls.lab_color_diamond);
    $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_color_diamond);
  }
  
} 
/*** End ***/

/*** Get Diamond Detail Page Meta Title Information ***/
function getDiamondDetailMetaTitle(diamondData,diamondType,shopName) {
  var page_meta_title = diamondData.caratWeight+" "+translations.titleCarat+" "+diamondData.shape+" "+translations.titleShape+" "+diamondType+" "+translations.titleDiamond+" | "+diamondData.lab+" "+translations.titleCertified+" - "+shopName; 
  return page_meta_title;
}
/*** End ***/

/*** Get Diamond Detail Page Meta Descripion Information ***/
function getDiamondDetailMetaDesc(diamondData,diamondType,shopName) {
  var page_meta_description = translations.titleShopForA+" "+diamondData.caratWeight+ " "+translations.titleCarat.toLowerCase()+" "+diamondData.shape.toLowerCase()+" "+diamondType.toLowerCase()+" "+translations.titleDiamondAt+" "+shopName+". "+translations.titleThisDiamondIsCertifiedBy+" "+diamondData.lab+", "+translations.titleFeaturingA+" "+diamondData.clarity+" "+translations.titleAnd+" "+diamondData.color+" "+translations.titleColorRating+".";
  return page_meta_description;
}
/*** End ***/

/*** Get Diamond Description Information ***/
function getDiamondDesc(diamondData,diamondType) {  
  var dia_description = translations.titleThis+" " + diamondData.caratWeight + " "+translations.titleCarat.toLowerCase()+", " + diamondData.color + " "+translations.titleColorDiamondRatedAsHaving+" " + diamondData.clarity + " "+translations.titleClarityWithA+" " + diamondData.shape.toLowerCase() + " "+translations.titleShapeSuppliedWithA+" " + diamondData.lab + " "+translations.titleGradingReport.toLowerCase()+".";
  return dia_description;
}
/*** End ***/

/*** Get Diamond Three C Information ***/
function getDiamondThreeCInfo(diamondData,diamondType) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  
  var diamond_threec_info = '<p>';
  diamond_threec_info += '<span><a href="'+diamond_certificate_url+'" target="_blank">' + diamondData.lab + ' '+translations.titleCertifiedCenterDiamond+'</a> | </span>';
  if(diamondData.cut != '' && diamondData.cut != 'Na' && diamondData.cut != 'NA'){
    diamond_threec_info += '<span>' + diamondData.cut + ' '+translations.titleCut+',</span>';
  }
  if(diamondData.color != ''){
    diamond_threec_info += '<span>' + diamondData.color + ' '+translations.titleColor+', </span>';
  }else{
    diamond_threec_info += '<span>' + diamondData.fancyColor + ' '+translations.titleColor+', </span>';
  }  
  diamond_threec_info += '<span>' + diamondData.clarity + ' '+translations.titleClarity+'</span>';  
  diamond_threec_info += '</p>';
  
  return diamond_threec_info;
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(diamondData) {  
  var diamondInformation = getDiamondDetailInformationLayout(diamondData);
  console.log('diamondData',diamondData);
  var detailInfo = '';  
  detailInfo += '<div class="tps-diamond-details">';
  // detailInfo += '<div class="tps-diamond-detail-section-heading active"><h2>'+translations.titleDiamondDetails+'</h2></div>';
  detailInfo += '<div class="tps-diamond-details-info">';   
  detailInfo += '<div class="detail-column-row-1 tps-single-info">';
  detailInfo += '<span class="detail-row-1 tps-txt-title">Stock Id</span>';
  detailInfo += '<span class="detail-row-2 tps-txt-info">'+diamondData.stockNumber+'</span>';
  detailInfo += '</div>';
  detailInfo += '</div>';
  detailInfo += '</div>';
  detailInfo += '<div class="tps-diamond-details">';
  detailInfo += '<div class="tps-diamond-detail-section-heading "><h2>'+translations.titleStneDetails+':</h2></div>';
  detailInfo += '<div class="tps-diamond-details-info">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Diamond detail Info Open Close ***/
$(document).on("click", ".tps-diamond-detail-section-heading", function() {
  if(jQuery(this).hasClass('active')){
    jQuery(this).removeClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-diamond-details-info').slideUp('slow');
  }else{
    jQuery(this).addClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-up').removeClass('tps-arrow-down');
    jQuery('.tps-diamond-details-info').slideDown('slow');
  }    
});
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getGridViewGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(diamondData.diamondType);    
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var diamondStockImage = [];
  // var diamondHandSliderImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {  
    if(diamondData.fancyColor == ''){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    // var handSliderDiamondImage = 'hand_slider_'+diamondData.shape.toLowerCase()+'_diamond';
    // if(diamondImage.includes(handSliderDiamondImage)){    
    //   diamondHandSliderImage.push(diamondImage);
    // }
  });
  
  var galleryHtml = '';  
  galleryHtml += '<div class="tps-main-slide tps-main-slide-image">';
  galleryHtml += '<div class="tps-slide">';
  galleryHtml += '<span class="tps-Factory-Direct">Factory Direct</span>';
  if(diamondData.diamondImage != '' && diamondData.diamondImage != 'NA' && diamondData.diamondImage != 'N/A' && diamondData.diamondImage != 'None'){
    galleryHtml += '<img class="tps-diamond-stock-image" src="'+diamondData.diamondImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="400" width="400">';
    jQuery("#diamond_image").val(diamondData.diamondImage);
  }else{      
    galleryHtml += '<img class="tps-diamond-stock-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="400" height="400">';
    jQuery("#diamond_image").val(diamondStockImage[0]);     
  }
  galleryHtml += '</div>';  
  galleryHtml += '</div>';   

  if(diamondData.diamondVideo != '' && diamondData.diamondVideo != 'None'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-video">';
    galleryHtml += '<div class="tps-slide">';  
    //galleryHtml += '<span class="tps_iframe_loader tps_iframe_loader_show"></span>';
    galleryHtml += getGallery360VideoLayout(diamondData);  
    galleryHtml += '</div>';
    galleryHtml += '</div>';   
  }

  if(threedEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-threed-model">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += getGalleryThreeDLayout(diamondData);
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
  }

  // if(handSliderEnable == 'true'){
  //   galleryHtml += '<div class="tps-main-slide tps-main-slide-hand-slider">';
  //   galleryHtml += '<div class="tps-slide">';
  //   galleryHtml += getGalleryHandSliderLayout(diamondData,imageUrls,diamondHandSliderImage[0]);
  //   galleryHtml += '</div>';
  //   galleryHtml += '</div>';  
  // }

  if(canvasImagesEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-front">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-two tps-canvas-image-front" id="tps_canvas_image_front"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
    
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-side">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-three tps-canvas-image-side" id="tps_canvas_image_side"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>';      
  }

  var diamond_certificate_url = getCertificateUrl(diamondData); 
  galleryHtml += '<div class="tps-main-slide tps-main-slide-certificate">';
  galleryHtml += '<div class="tps-slide"><div class="tps-certificate-images"><a href="'+diamond_certificate_url+'" class="tps-final-gallery-slide-certificate-link" title="'+diamondData.lab+'" target="_blank">';
  // galleryHtml += getGalleryHandSliderLayout(diamondData,imageUrls,diamondHandSliderImage[0]);
  galleryHtml += imageUrls.certificateImage;
  galleryHtml += '</a></div>';
  galleryHtml += '<span class="tps-gallery-slide-lable">'+diamond_type+'</span>';  
  galleryHtml += '</div>';
  galleryHtml += '<a href="'+diamond_certificate_url+'" class="tps-gallery-slide-certificate-link" title="'+translations.titleViewCertificate+'" target="_blank">'+translations.titleViewCertificate+'</a>';
  galleryHtml += '</div>';
  
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getThumbSliderGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(diamondData.diamondType);    
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var mainImageGallery = getGridViewGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);
  var thumbImageGallery = getThumbnailGalleryLayout(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);

  var galleryHtml = '';
  galleryHtml += '<div class="tps-main-image-slide">';
  galleryHtml += mainImageGallery;
  galleryHtml += '</div>';

  if(jQuery(window).width() <= 767){
    galleryHtml += '<div class="tps-swiper-scrollbar" id="tps_gallery_scrollbar"><div class="tps-swiper-scrollbar-drag" id="tps_gallery_scrollbar_drag"></div></div>';
  }

  // galleryHtml += '<div class="tps-thumb-image-slide">';
  // galleryHtml += thumbImageGallery;
  // galleryHtml += '</div>';    
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Gallery Thumbnail Layout ***/
function getThumbnailGalleryLayout(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var diamondStockImage = [];
  var modalStockImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    if(diamondData.fancyColor == ''){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    var modalImageParam = '3d_'+diamondData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(modalImageParam)){    
      modalStockImage.push(diamondImage);
    }    
  });
  
  var galleryThumbHtml = '';
  galleryThumbHtml += '';  
  galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  galleryThumbHtml += '<div class="tps-thumb">';
  if(diamondData.diamondImage != '' && diamondData.diamondImage != 'NA' && diamondData.diamondImage != 'None' && diamondData.diamondImage != 'N/A'){
    galleryThumbHtml += '<img src="'+diamondData.diamondImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
  }else{      
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';           
  }
  galleryThumbHtml += '</div>';  
  galleryThumbHtml += '</div>';   

  if(diamondData.diamondVideo != '' && diamondData.diamondVideo != 'None'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">'; 
    galleryThumbHtml += '<span class="tps-video-play-icon"></span>';     
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  if(threedEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += '<img src="'+modalStockImage[0]+'" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>'; 
  }

  // if(handSliderEnable == 'true'){
  //   galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  //   galleryThumbHtml += '<div class="tps-thumb">';
  //   galleryThumbHtml += '<img src="'+imageUrls.handSliderImage+'" onClick="renderSliders(`'+diamondData.caratWeight+'`)" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
  //   galleryThumbHtml += '</div>';
  //   galleryThumbHtml += '</div>';  
  // }

  if(canvasImagesEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasFrontImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  

    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasSideImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  var diamond_certificate_url = getCertificateUrl(diamondData); 
  galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  galleryThumbHtml += '<div class="tps-thumb">';
  galleryThumbHtml += imageUrls.certificateImage;
  galleryThumbHtml += '</div>';
  galleryThumbHtml += '</div>';
  
  return galleryThumbHtml;
}
/*** End ***/

// function getDiamondThumbStockImage(diamondData) {
//   $.each(diamondImageUrl, function(i, diamondImage) {   
//     if(diamondData.fancyColor == ''){
//       var imageParam = diamondData.shape.toLowerCase()+'_generic.png';
//     }else{
//       var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic.png';
//     }     
    
//     if(diamondImage.includes(imageParam)){         
//       var thumbImageUrl = diamondImage;
//       return thumbImageUrl;
//     }
//   });
// }

/*** Get Diamond Gallery 360 Video HTML ***/
function getGallery360VideoLayout(diamondData) {
   var video_url = diamondData.diamondVideo;
  
   if(video_url != ''){
    var videoHtml = '';
    if (video_url.indexOf("mp4") > -1 || video_url.indexOf(".mov") > -1) {
      videoHtml ='<video class="tps-dia-gallery-video" controls autoplay playsinline>';
      videoHtml +='<source src="'+video_url+'" type="video/mp4">';
      videoHtml +='</video>';     
    }else{
       videoHtml ='<iframe class="tps-dia-gallery-video-iframe tps-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" scrolling="no"></iframe>';

       //set iframe width as per device
       if (video_url.indexOf("https://loupe360.com/diamond/") > -1){              
          video_url = video_url.replace('/500/500', '/resp/true/autoplay');
          videoHtml ='<iframe class="tps-dia-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" width="500px" height="500px" scrolling="no"></iframe>';
       }        
      
    }
    return videoHtml;
  }  
}
/*** End ***/

/*** Get Diamond 3D Model HTML ***/
function getGalleryThreeDLayout(diamondData) {
  var shape = diamondData.shape;
  var width = diamondData.width;
  var length = diamondData.length;
  var depth = diamondData.depth;  
  var deptPerc = diamondData.deptPerc; 
  var table = diamondData.tablePerc;
  var girdle = diamondData.girdle;
  if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }

  var threed_url = '';
  threed_url += 'https://php71.transpacific-software.com/3d_diamond/index.php?getShape='+shape.toLowerCase();
  threed_url += '&getWidth='+width;
  threed_url += '&getLength='+length;
  threed_url += '&getDepth='+deptPerc;
  threed_url += '&getTable='+table;
  if(girdle != '' && girdle != null){
    threed_url += '&getGirdle='+girdle;
  }else{
    threed_url += '&getGirdle=NA';
  }

  if(threed_url != ''){    
    theedHtml ='<iframe class="tps-dia-gallery-threed-model" src="'+threed_url+'" height="400px" width="400px" scrolling="no"></iframe>';	
    return theedHtml;
  }
}
/*** End ***/

/*** Get Gallery Hand Slider Layout ***/
function getGalleryHandSliderLayout(diamondData,imageUrls) {
  var diamondHandSliderImage = [];

  // Normalize shape for image filenames
  let imageShape = diamondData.shape.trim();

  if (imageShape === "Cushion Brilliant") {
      imageShape = "Cushion";
  } else if (imageShape === "Square Radiant") {
      imageShape = "Radiant";
  }
  
  imageShape = imageShape.replace(/\s+/g, '-').toLowerCase();

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    var handSliderDiamondImage = 'hand_slider_'+imageShape.toLowerCase()+'_diamond';
    if(diamondImage.includes(handSliderDiamondImage)){    
      diamondHandSliderImage.push(diamondImage);
    }
  });
  
  handSliderHtml = '';
  handSliderHtml += '<div class="tps-diamond-hand-slider">';
  // handSliderHtml += '<span class="hand_diamond_img tps-diamond-icon-'+diamondData.shape.toLowerCase()+'"></span>';
  handSliderHtml += '<img id="tps-gallery-thumb-white" class="tps-gallery-hand-slider-white" src="'+imageUrls.handSliderWhite+'" title="Hand slider white image" alt="Hand slider white image" height="auto" width="auto">';
  handSliderHtml += '<span class="tps-hand-diamond-image"><img id="tps-gallery-hand-diamond-image" class="tps-gallery-hand-diamond-image" src="'+diamondHandSliderImage[0]+'" title="Hand slider diamond" alt="Hand slider diamond" height="auto" width="auto"></span>';
  //handSliderHtml += '<img id="tps-gallery-thumb-black" class="tps-gallery-hand-slider-dark" src="'+imageUrls.handSliderDark+'" title="Hand slider dark image" alt="Hand slider dark image" height="auto" width="auto">';
  handSliderHtml += '</div>';  

  handSliderHtml += '<div class="tps-diamond-hand-carat-slider">';
  handSliderHtml += '<span class="left-slide">0.20 ct.</span>';
  handSliderHtml += '<span class="right-slide">10 ct.</span>';
  handSliderHtml += '<div id="hand-carat-slider" class="caratlearnmore"></div>';  
  handSliderHtml += '<div class="min-carat-detail" id="min_carat_detail"></div>';
  handSliderHtml += '</div>';

  // handSliderHtml += '<div class="tps-diamond-hand-color-slider">';
  // handSliderHtml += '<span class="left-slide">'+translations.titleLighter+'</span>';
  // handSliderHtml += '<span class="right-slide">'+translations.titleDarker+'</span>';
  // handSliderHtml += '<div id="hand-color-slider" class="handcolorslider"></div>';  
  // handSliderHtml += '</div>';

  setTimeout(function(){
    hand_carat_slider_render(diamondData.caratWeight);
    hand_color_slider_render(diamondData);
  }, 1000);
  
  return handSliderHtml;   
}
/*** End ***/

/*** Rendar Hand & Carat Slider Start ***/
function renderSliders(diamondCarat) {
    hand_carat_slider_render(diamondCarat);
    hand_color_slider_render();
}
/*** Rendar Hand & Carat Slider End ***/

/*** Gallery Hand Color Slider ***/
function hand_color_slider_render() {
  $("#hand-color-slider").slider({
          step:0.01,
          min: 0.00,
          max: 1.00,
          value: 0.50,
          slide: function(event, ui) {
             var diamondcarat = ui.value;             
             $('#tps-gallery-thumb-black').css('opacity', diamondcarat);              
          },
          change: function(event, ui) {            
            var diamondcarat = ui.value;
            $('#tps-gallery-thumb-black').css('opacity', diamondcarat);  
          },
  });
}
/*** End ***/

/*** Gallery Hand Carat Slider ***/
function hand_carat_slider_render(diamondCarat) {
  const dpiDesktop = 96;        // Common desktop DPI
  const dpiIpad = 264;          // iPad Pro PPI
  const dpiIpadMini = 326;      // iPad Mini PPI
  const dpiHighResPhone = 450;  // High-resolution phone (like iPhone)  
  var diamondcarat = diamondCarat;
      
  $("#hand-carat-slider").slider({
            step: 0.001,
            min: 0.20,
            max: 10,
            value: diamondcarat,
            create: function() {         
                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
              
                jQuery('#min_carat_detail').appendTo(jQuery('#hand-carat-slider a').get(0));
                jQuery('#hand-carat-slider').slider("value", diamondcarat);  
            },
            slide: function(event, ui) {    
                var diamondcarat = ui.value; 
              
                var delay = function() {
                    var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                    $('#tps-gallery-hand-diamond-image').css({
                      'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                      'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                    });

                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");
                };
                setTimeout(delay, 5);
         },
        change: function(event, ui) {              
                var diamondcarat = ui.value;

                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);
                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
          
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");                         
                };
                setTimeout(delay, 600);
         },
    });
}
/*** End ***/

/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) Start ***/
function caratToMm(caratWeight) {
    return Math.cbrt(caratWeight / 0.0061).toFixed(2); // Return the size in mm
}
/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) End ***/

/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) Start ***/
function mmToPixels(mm, dpi) {
    return ((dpi * mm) / 25.4).toFixed(2); // Return size in pixels rounded to 2 decimals
}
/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) End ***/

/*** Function To Convert Carats To Pixel Size Based On Device DPI Start ***/
function caratToPixelSize(caratWeight, dpi) {
    // Step 1: Convert carat to millimeters
    const mmSize = caratToMm(caratWeight);
    
    // Step 2: Convert millimeters to pixels based on device DPI
    let pixelSize = mmToPixels(mmSize, dpi);
    
    // Optional: Apply scaling factor for visual purposes
    // let scalingFactor = 2; // Adjust this factor based on the size you want
    // pixelSize *= scalingFactor;
    
    // return pixelSize;
    return pixelSize *= 1, pixelSize;
}
/*** Function To Convert Carats To Pixel Size Based On Device DPI End ***/

/*** Get Gallery Canvas Image Layout ***/
function getCanvasLayout(diamondData) {
    var shape = diamondData.shape;
    var gridle = diamondData.girdle;
    if(gridle == '' || gridle == 'undefined' || gridle == 'Undefined' || gridle == null   || gridle == "null" || gridle == undefined){
      if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
        gridle = diamondData.girdleMin+"-"+diamondData.girdleMax;
      }else{
        gridle = "-";
      }      
    }
  
   var height = diamondData.depth;
   var dia_length = diamondData.length;
   var dia_width = diamondData.width;
   var dia_carat = diamondData.caratWeight;
   var culet = diamondData.culet;
   var width = diamondData.width;
   var length = diamondData.length;
   var depth = diamondData.depth;  
   var deptPerc = diamondData.deptPerc; 
   var table = diamondData.tablePerc;

   if(shape=='Round'){
      var table_width='195';
      var table_height='38';
      var depth_width='310';
      var depth_height='130';
      var depth_per_width='80';
      var depth_per_height='150';
      var gridle_width='101';
      var gridle_height='210';
      var culet_width='190';
      var culet_height='220';
      var width_height='17';
      var width_width='194';
      var length_height='145';
      var length_width='65';
    }

    if(shape=='Princess'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='147';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_height='15';
      var width_width='185';
      var length_height='145';
      var length_width='45';
    }

    if(shape=='Cushion' || shape=='Cushion Modified' || shape == 'Cushion Brilliant'){ 
      var table_width='200';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='120';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215';    
      var width_height='19';
      var width_width='190';
      var length_height='145';
      var length_width='50';
    }

    if(shape=='Radiant' || shape=='Square Radiant'){
      var table_width='200';
      var table_height='34';
      var depth_width='310';
      var depth_height='147';
      var depth_per_width='85';
      var depth_per_height='160';
      var gridle_width='140';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215'; 
      var width_height='14';
      var width_width='190';
      var length_height='145';
      var length_width='48';
    }

    if(shape=='Asscher'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='148';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_width='180';
      var width_height='15';
      var length_height='145';
      var length_width='42';
    }

    if(shape=='Emerald'){
      var table_width='200';
      var table_height='40';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205'; 
      var width_width='190';
      var width_height='12';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Oval'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='112';
      var gridle_height='200';
      var culet_width='220';
      var culet_height='195'; 
      var width_width='200';
      var width_height='17';
      var length_height='150';
      var length_width='80';
    }

    if(shape=='Pear'){
      var table_width='210';
      var table_height='45';
      var depth_width='310';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='124';
      var gridle_height='200';
      var culet_width='245';
      var culet_height='195'; 
      var width_width='195';
      var width_height='15';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Marquise'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='120';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='200'; 
      var width_width='192';
      var width_height='17';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Heart'){
      var table_width='210';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='132';
      var gridle_height='215';
      var culet_width='240';
      var culet_height='210'; 
      var width_width='185';
      var width_height='18';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Square'){
      var table_width='200';
      var table_height='43';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205';
      var width_width='200';
      var width_height='17';
      var length_height='145';
      var length_width='65';
    }
   
    drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height);
    drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height);
}
/*** End ***/

/*** Draw Diamond Canvas Side Image ***/
function drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height) {

    var circle_canvas = document.getElementsByClassName("tps-canvas-image-side")[0]; 
    
    var context = circle_canvas.getContext("2d");
      
    var depth1;
    if(height==''){
      depth1 = width;
    } else {
      depth1 = height;	
    }
  
    if(culet==''){
      culet='None';
    }
  
    // if(gridle==''){
    //   gridle='';
    // }	
    
    // Fill Style
    context.fillStyle = "rgb(0,0,0,0.80)";
      
    // Begin path
    context.beginPath();
    
    var img = new Image();
    img.src = $(".tps-canvas-thumb-image-side").attr('src');    
    img.onload = function() {  
      context.canvas.height = this.height;
      context.canvas.width = this.width;
      context.drawImage(img, 0, 0);
      context.font = "11px/bold open sans, arial"; 
      context.fillStyle = "#000000";
      context.fillText(table, table_width, table_height);
      context.fillText(deptPerc, depth_width, depth_height);
      context.fillText(gridle, gridle_width, gridle_height);
      // if(shape=='Marquise'){ 
      //   context.fillText(culet, culet_width, culet_height);
      // }
  };  
} 
/*** End ***/

/*** Draw Diamond Canvas Front Image ***/
function drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height) {

  var circle_canvas = document.getElementsByClassName("tps-canvas-image-front")[0];

  var context = circle_canvas.getContext("2d");

  var depth1;

  if(height==''){ 
    depth1=width;
  }else{ 
    depth1=height;   
  }  

  if(culet==''){ 
    culet='None'; 
  }

  if(gridle==''){ 
    gridle='-';
  } 

  // Fill Style
  context.fillStyle = "rgb(93,179,195,0.20)"; 
  context.beginPath();  
  
  var img = new Image();
  img.src =$(".tps-canvas-thumb-image-front").attr('src'); 
  img.onload = function() {             
    context.canvas.height = this.height;
    context.canvas.width = this.width;
    context.drawImage(img, 0, 0); 
    context.font = "11px/bold open sans, arial"; 
    context.fillStyle = "#000000";
    context.fillText(dia_width, width_width, width_height); 
    context.fillText(dia_length, length_width, length_height); 
  };
}
/*** End ***/

/*** Dynamic Swiper-style Scrollbar for Slick Gallery Start ***/
function initGalleryScrollbar(sliderSelector, scrollbarSelector, dragSelector) {
  var $slider    = $(sliderSelector);
  var $scrollbar = $(scrollbarSelector);
  var $drag      = $(dragSelector);

  if (!$slider.length || !$scrollbar.length) return;

  function updateScrollbar(currentSlide) {
    var slick = $slider.slick('getSlick');
    if (!slick) return;

    var total = slick.slideCount;
    currentSlide = currentSlide || 0;

    // drag width = proportion of gallery currently "visible" (1 slide out of total)
    var dragWidthPct = Math.max((1 / total) * 100, 8); // 8% floor so it's never a sliver
    // left position = how far through the gallery we are
    var maxLeft = 100 - dragWidthPct;
    var leftPct = total <= 1 ? 0 : (currentSlide / (total - 1)) * maxLeft;

    $drag.css({
      width: dragWidthPct + '%',
      left: leftPct + '%'
    });
  }

  // Sync scrollbar whenever Slick changes slide
  $slider.on('init afterChange', function (event, slick, currentSlide) {
    updateScrollbar(currentSlide);
  });

  // Initialize immediately in case 'init' already fired before this binds
  updateScrollbar($slider.slick('slickCurrentSlide') || 0);

  // Drag / click-to-seek on the track
  var dragging = false;

  function seekFromEvent(e) {
    var slick = $slider.slick('getSlick');
    if (!slick) return;

    var rect = $scrollbar[0].getBoundingClientRect();
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    var total = slick.slideCount;
    var targetSlide = Math.round(pct * (total - 1));

    $slider.slick('slickGoTo', targetSlide);
  }

  $scrollbar.off('.tpsScrollbar').on('mousedown.tpsScrollbar touchstart.tpsScrollbar', function (e) {
    dragging = true;
    seekFromEvent(e);
    e.preventDefault();
  });

  $(document).off('.tpsScrollbar').on('mousemove.tpsScrollbar touchmove.tpsScrollbar', function (e) {
    if (dragging) seekFromEvent(e);
  });

  $(document).on('mouseup.tpsScrollbar touchend.tpsScrollbar', function () {
    dragging = false;
  });
}
/*** Dynamic Swiper-style Scrollbar for Slick Gallery End ***/

/*** Gallery Thumbnail Slider Script Code Start ***/
function galleryThumbnailSlider(verticalSlider){
    $('.tps-main-image-slide').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: false,
       arrows: true,       
       adaptiveHeight: true,
       draggable: false,
       lazyLoad: 'progressive',
       dots: false
   });

   initGalleryScrollbar('.tps-main-image-slide', '#tps_gallery_scrollbar', '#tps_gallery_scrollbar_drag');

  // if(verticalSlider == true){
  //     $('.tps-thumb-image-slide').slick({
  //        vertical: true,
  //        verticalSwiping: true,
  //        slidesToShow: 4,
  //        slidesToScroll: 1,
  //        infinite: false,
  //        asNavFor: '.tps-main-image-slide',        
  //        focusOnSelect: true,
  //        draggable: false, 
  //        arrows: true,
  //        lazyLoad: 'progressive',
  //    });
  // }else{
  //     $('.tps-thumb-image-slide').slick({
  //        slidesToShow: 5,
  //        slidesToScroll: 1,
  //        infinite: true,
  //        asNavFor: '.tps-main-image-slide',
  //        dots: false,
  //        arrows: false,     
  //        // variableWidth: true,
  //        focusOnSelect: true,
  //        draggable: false,
  //        lazyLoad: 'progressive',
  //        responsive 		: [
	// 	  		{
	// 		      	breakpoint: 1440,
	// 		      	settings: {
	// 		        	slidesToShow 	: 4,
	// 		        	slidesToScroll 	: 1,
	// 		        	adaptiveHeight  : true,			        	
	// 		      	}
	// 		    },
	// 	  		{
	// 		      	breakpoint: 992,
	// 		      	settings: {
	// 		        	slidesToShow 	: 5,
	// 		        	slidesToScroll 	: 1,
	// 		        	adaptiveHeight  : true,			        	
	// 		      	}
	// 		    },
	// 	  		{
	// 		      	breakpoint: 768,
	// 		      	settings: {
	// 		        	slidesToShow 	: 5,
	// 		        	slidesToScroll 	: 1,
	// 		        	adaptiveHeight  : true,			        	
	// 		      	}
	// 		    },
	// 		    {
	// 		      	breakpoint: 640,
	// 		      	settings: {
	// 		        	slidesToShow 	: 4,
	// 		        	slidesToScroll 	: 1,
	// 		        	adaptiveHeight  : true,			        	
	// 		      	}
	// 		    },
	// 		    {
	// 		      	breakpoint: 581,
	// 		      	settings: {
	// 		        	slidesToShow 	: 4,
	// 		        	slidesToScroll 	: 1,
	// 		        	adaptiveHeight  : true,			        	
	// 		      	}
	// 		    },
	// 	 	], 
  //    });
  // }
   
}
/*** End ***/

/*** Diamond Four C's Section Script ***/
// function diamondFourCSection(diamondData){
//   var diamondType = diamondData.diamondType;
//   var diamondcarat = parseFloat(diamondData.caratWeight);
//   var diamondshape = diamondData.shape.toLowerCase();
  
//   var carat_array = ['0.10-0.5','0.5-1','1-2','2-3','3-4','4-5','5-6','6-7','7-8','8-9','9-10'];
//   $(".tps-carat-icon").addClass('tps-carat-icon-'+diamondshape);
//   $(carat_array).each(function(index, caratvalue) { 
//     var carat = caratvalue.split('-');
//     var carat_min = parseFloat(carat[0]);
//     var carat_max = parseFloat(carat[1]);
//     carat_min = carat_min.toFixed(2);
//     carat_max = carat_max.toFixed(2);
    
//     if(diamondcarat == carat_min){
//       var carat_min = carat_min.replace('.', '-');
//       $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active');
//     }else if(diamondcarat == carat_max){
//       var carat_max = carat_max.replace('.', '-');
//       $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_max).addClass('active');
//     }else if(diamondcarat >= carat_min && diamondcarat <= carat_max){
//       var carat_min = carat_min.replace('.', '-');
//       $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active'); 
//       $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('pointer'); 
//       // $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>'+diamondcarat+'</span></div>');
//       // $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.</span></div>');
//       $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.</span></div>');
//     }    
    
//   });        
//   $("#tps_dia_carat_weight").html(diamondData.caratWeight);

//   if(diamondData.fancyColor == ''){
//      $("#tps_dia_color").html(diamondData.color);
//      $(".tps-color-"+diamondData.color).addClass('active');
//      $(".tps-four-cs-fancy-color-section").remove();  
//   }else{
//     $("#tps_dia_fancy_color").html(diamondData.fancyColor);
//     $(".tps-fancy-color-"+diamondData.fancyColor).addClass('active');
//     $(".tps-four-cs-color-section").remove();
//   }    

//   if(diamondData.shape == "Round"){
//     var diamondCut = diamondData.cut;
//     $("#tps_dia_cut").html(diamondData.cut);
//     if (diamondCut.indexOf("Very ") >= 0){
//       diamondCut = diamondCut.replace(' ','-');
//       $(".tps-cut-"+diamondCut).addClass('active');
//     }else{
//       $(".tps-cut-"+diamondCut).addClass('active');
//     }
//   }else{
//     $(".tps-four-cs-cut-section").remove(); 
//   }      
  
//   $("#tps_dia_clarity").html(diamondData.clarity);
//   $(".tps-clarity-"+diamondData.clarity).addClass('active');
// }
/*** End ***/

/*** Diamond Details C's Section Script ***/
function diamonddetailsFourCSection(diamondData){
  var diamondType = diamondData.diamondType;
  var diamondcarat = parseFloat(diamondData.caratWeight);
  var diamondshape = diamondData.shape.toLowerCase();
  
  $(".tps-diamond-info-card-carat-weight .tps-selected-value").html(diamondData.caratWeight+' ct.');
  
  if(diamondData.fancyColor == ''){
    $(".tps-diamond-info-card-color .tps-selected-value").html(diamondData.color);  

    $(".tps-diamond-info-card-color .tps-tab-btn").each(function () {
        if ($(this).data("title") == diamondData.color) {
            $(this).trigger("click");
        }
    });

    // $(".tps-diamond-info-card-fancy-color").remove();
    $(".tps-diamond-info-card-fancy-color").parent().remove();      
  }else{  
    var diamondImage = $("#diamond_image").val();
    $(".tps-diamond-info-card-fancy-color .tps-main-image").attr("src", diamondImage);
    $(".tps-diamond-info-card-fancy-color .tps-selected-value").html(diamondData.fancyColorIntensity); 
    
    $(".tps-diamond-info-card-fancy-color .tps-tab-btn").each(function () {
        let title = $(this).data("title");

        if (
            title === diamondData.fancyColorIntensity ||
            title.endsWith(diamondData.fancyColorIntensity)
        ) {
            $(this).trigger("click");
            return false;
        }
    });

    //$(".tps-diamond-info-card-color").remove();  
    $(".tps-diamond-info-card-color").parent().remove();
  }    

  if(diamondData.shape == "Round"){
    var diamondCut = diamondData.cut;
    $(".tps-diamond-info-card-cut .tps-selected-value").html(diamondCut); 

    $(".tps-diamond-info-card-cut .tps-tab-btn").each(function () {
        var tabValue = $(this).data("title").toString().trim().toLowerCase();
        var targetValue = diamondCut.toString().trim().toLowerCase();

        if (tabValue === targetValue) {
            $(this).trigger("click");
        }
    });    
  }else{
    // $(".tps-diamond-info-card-cut").remove(); 
    $(".tps-diamond-info-card-cut").parent().remove();
  }      

  $(".tps-diamond-info-card-clarity .tps-selected-value").html(diamondData.clarity); 
  $(".tps-diamond-info-card-clarity .tps-tab-btn").each(function () {
      if ($(this).data("title") == diamondData.clarity) {
          $(this).trigger("click");
      }
  });
}
/*** End ***/

/*** Loose Diamond Add To Cart Start ***/
function buyLooseDiamond(diamond_type,flag){   
  var diamondAddToCart = labDiamondAddToCart;

  if(flag == 'add-to-cart'){
    var buttonId = '#tps_buy_loose_diamond';    
  }else{
    var buttonId = '#tps_buy_with_shop';
  }

  jQuery(buttonId).addClass('tps-loading');
  
  var diamond_image = jQuery('.tps-diamond-stock-image').attr('src');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${diamondAddToCart}(diamondId: "` +
              diamond_id +
              `", diamondType:"` +
              diamond_type +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {         
        var variant_id = response?.data?.diamondAddToCart?.variantId; 
                
        setTimeout(function(){ 
          
            // var productSku = [];
            
            jQuery.getJSON('/cart.js', function(cart) {
              var diamondExists = false;
             if(cart.items != '' ){                     
               $(cart.items).each(function(index, value) { 
                  var cartSku = value.sku || '';
                  var diamondSku = String(diamond_id);

                  // Case 1: Cart SKU is exactly the diamond SKU
                  if (cartSku === diamondSku) {
                      diamondExists = true;
                      return false;
                  }

                  // Case 2: Cart SKU is a product SKU containing the diamond SKU
                  var skuParts = cartSku.split('-');

                  if ($.inArray(diamondSku, skuParts) !== -1) {
                      diamondExists = true;
                      return false;
                  }                                 
               });
                 
               jQuery(buttonId).removeClass('tps-loading');            
                               
               setTimeout(function(){ 
                if (diamondExists) {
                  alert(translations.titleProductAlreadyInCart);                  
                  jQuery(buttonId).removeClass('tps-loading');            
                }else{                        
                  addtocart(variant_id,flag,buttonId);
                }
              }, 50);                    
             }else{
               addtocart(variant_id,flag,buttonId);
             }              
            });                                  
          
        }, 1600); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);                     
          jQuery(buttonId).removeClass('tps-loading');            
       }
    }); 
}
  
// function addtocart(add_id,flag,buttonId){   
//   if(flag == 'add-to-cart'){
//     jQuery.post('/cart/add.js', {
//       quantity:1,
//       id: add_id,
//     });
  
//     setTimeout(function(){
//       window.location.href = "/cart";
//     }, 1500);  

//     jQuery(buttonId).removeClass('tps-loading');
//   }else{
//     renderAndTriggerShopPayButton(add_id,buttonId);
//   }
// }

function addtocart(add_id, flag, buttonId) {
  if (flag == 'add-to-cart') {
    jQuery(buttonId).addClass('tps-loading');

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: add_id
      },
      dataType: 'json',

      success: function(response) {

        // Get updated cart
        jQuery.getJSON('/cart.js', function(cart) {
          // Update cart count
          jQuery('.cart-count-bubble').html(cart.item_count);
          // Refresh cart drawer
          refreshCartDrawer();
          jQuery(buttonId).removeClass('tps-loading');
        }).fail(function() {
          jQuery(buttonId).removeClass('tps-loading');
        });
      },

      error: function(xhr) {
        console.log('Add to cart error:', xhr.responseText);
        jQuery(buttonId).removeClass('tps-loading');
      }
    });
  } else {
    renderAndTriggerShopPayButton(add_id, buttonId);
  }
}

function refreshCartDrawer() {
  fetch('/?sections=cart-drawer')
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {

      var parser = new DOMParser();
      var html = parser.parseFromString(
        data['cart-drawer'],
        'text/html'
      );

      var newDrawer = html.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        // Open drawer
        currentDrawer.classList.add('active');
        // Shopify drawer classes
        currentDrawer.classList.remove('is-empty');
      }

    })
    .catch(function(error) {
      console.log('Cart drawer refresh error:', error);
    });
}

function renderAndTriggerShopPayButton(variantId,buttonId) {
  // Load the SDK once (skip if already loaded)
  if (!document.querySelector('script[src*="loader.pay-button.esm.js"]')) {
    var script = document.createElement('script');
    script.src = "https://cdn.shopify.com/shopifycloud/shop-js/modules/v2/loader.pay-button.esm.js";
    script.type = "module";
    document.head.appendChild(script);
  }

  var container = document.getElementById('tps_shop_pay_button_container');
  container.innerHTML = `
    <shop-pay-button
      store-url="https://${Shopify.shop}"
      variants="${variantId}">
    </shop-pay-button>
  `;
  container.style.display = 'none';

  // Auto-click it once it's ready
  setTimeout(function () {
    var shopPayEl = container.querySelector('shop-pay-button');
    if (shopPayEl && shopPayEl.shadowRoot) {
      var btn = shopPayEl.shadowRoot.querySelector('button');
      if (btn) btn.click();
      jQuery(buttonId).removeClass('tps-loading');
    }
  }, 500);
}


/*** Loose Diamond Add To Cart Start ***/
function createDiamondProduct(diamond_type){    
  if(diamond_type == 'natural-white'){
    var diamondAddToCart = naturalDiamondAddToCart;
  }else{
    var diamondAddToCart = labDiamondAddToCart;
  }
  jQuery("#tps_add_diamond_to_wishlist").addClass('tps-loading');
  var diamond_image = jQuery('.tps-diamond-stock-image').attr('src');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${diamondAddToCart}(diamondId: "` +
              diamond_id +
              `",diamondType:"` +
              diamond_type +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) { 
        if(diamond_type == 'natural-white'){
          var productId = response.data.naturalDiamondAddToCart.productId;  
        }else{
          var productId = response.data.diamondAddToCart.productId;       
        }
        
        setTimeout(function(){ 
            addRemoveProductToWishlist(productId,'diamond');
            jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
            
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);           
         jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
       }
    }); 
}
  
// function addtocart(add_id){   
//   jQuery("#tps_buy_loose_diamond").removeClass('tps-loading');
//   jQuery.post('/cart/add.js', {
//     quantity:1,
//     id: add_id,
//   });
 
//   setTimeout(function(){
//     window.location.href = "/cart";
//   }, 1000);   
// }
/*** End ***/

function similarDiamondSection(allSimDiamondData){
  if(allSimDiamondData != '' && allSimDiamondData != null){     
    var diaGridView = '';
    $.each(allSimDiamondData, function(i, diamondData) { 
      //  diaListView += getDiamondListingViewLayout(diamondData,compare_diamonds,active_tab);
      if (i >= 8) {
        return false; // Break the $.each loop
      }
       diaGridView += getDiamondListingGridLayout(diamondData,'','',i);
    });    
  }else{
    console.log("no diamonds found");
  }

  var diamondListingLayout = diaGridView;
  jQuery('.tps-similar-diamonds').html(diamondListingLayout);
  initSimilarDiamondSlider();
}

/*** Diamonds Listing Grid Layout Start ***/
function getDiamondListingGridLayout(diamondData,compare_diamonds,active_tab,diamondIndex) {  
  var page_no = '1';
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = diamondIndex+1;   
  var shop_currency = jQuery('#shop_currency').val();
  var currency_rate = Shopify.currency.rate;
  
  var diamond_id = diamondData.diamondId;
  var diamond_shape = diamondData.shape;
  var diamond_type = getDiamondType(diamondData.diamondType);   
  var diamond_title = getDiamondName(diamondData,diamond_type);   
  var diamond_certificate_url = getCertificateUrl(diamondData); 
  var saving_price = Number(diamondData.markupPriceUsd - diamondData.finalPriceUsd);
      saving_price = Shopify.formatMoney(saving_price * 100, theme.moneyFormat);
      saving_price = saving_price.replace(/([.,])00$/, '');
  var final_price = diamondData[getDiamondDefaultFinalPriceField(shop_currency)];
  var diamond_price = getDiamondPrice(currency_rate,final_price);  
   var comp_final_price = diamondData[getDiamondDefaultComparFinalPriceField(shop_currency)];  
  var compare_price = getDiamondPrice(currency_rate,comp_final_price);
  var dia_img = diamondData.diamondImage;
  var diamondStockImage = [];
  var diamonGridInfoShow = jQuery('#diamond_grid_info_display').val();
  
  if(dia_img == 'None' ){
     //get diamond stock image url
      $.each(diamondImageUrl, function(i, diamondImage) {   
        if(session_variable == 'natural-white-diamond' || session_variable == 'lab-white-diamond'){
          var imageParam = diamondData.shape.toLowerCase()+'_generic';
        }else{
          var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
        }     
        
        if(diamondImage.includes(imageParam)){    
          diamondStockImage.push(diamondImage);
        }
      });
  }
   
  // var wishlistProducts = jQuery("#wishlist_products").val();
  // wishlistProducts = wishlistProducts.split(",");

  var compareClass = '';
  if($.inArray(diamondData.diamondId.toString(), compare_diamonds)!=(-1)){
    var compareClass = 'active';            
  }

  diaGrid = '';
  // if(active_tab == 'compare'){
  //   diaGrid += '<li class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'" data-compare-id="' + diamond_id + '">';
    
  // }else{
    diaGrid += '<div class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'">';
  // }
  // if(diamondData.diamondType == 'lab-white' || diamondData.diamondType == 'lab-fancy'){
  //   diaGrid += '<div class="tps-diamondlist-item-badget-span">';
  //   diaGrid += '<div class="tps-diamondlist-item-badget-span-list">';
  //   diaGrid += '<div class="tps-diamondlist-result-badget-info tps-diamondlist-result-badget-info-lab">'+translations.titleLab+'</div>';
  //   if(diamondData.process != '' && diamondData.process != null){
  //     var processTitle = [];
  //     $.each(lab_process_array, function(key,process){      
  //       if(diamondData.process == key){
  //         processTitle.push(process);
  //       }
  //     });
  //     diaGrid += '<div class="tps-diamondlist-result-badget-info tps-diamondlist-result-badget-treatment" title="'+processTitle[0]+'">'+diamondData.process+'</div>';
  //   }
  //   diaGrid += '</div>';
  //   diaGrid += '</div>';
  // }
  // if(diamondData.quickShip == 'yes'){
  //   diaGrid += '<div class="tps-diamondlist-item-quickship-span">';
  //   diaGrid += '<span class="tps-diamondlist-result-grid-quickship-span tps-diamond-quickship-span">quickShip</span>';
  //   diaGrid += '</div>';
  // }
  //  diaGrid += '<div class="tps-diamondlist-item-newIn-label"><label>New In</label></div>';
  diaGrid += '<div class="tps-diamondlist-item-info-span">';
  diaGrid += '<div class="tps-diamondlist-item-info-span-list">';
  
  if(diamonGridInfoShow == 'false'){
    diaGrid += '<div class="tps-diamondlist-result-grid-info">';
    diaGrid += '<span class="tps-diamondlist-result-grid-info-span tps-diamond-info-span" title="'+translations.titleMoreInformation+'" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`grid`,`open`,event);">info</span>';
    diaGrid += '</div>';
  }    
  
  // if(active_tab == 'all'){
  //   diaGrid += '<div class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' '+compareClass+'">';
  //   diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" title="'+translations.titleCompareDiamonds+'" onclick="event.stopPropagation();compareDiamonds(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
  //   diaGrid += '</div>';
  // }else if(active_tab == 'compare'){
  //   diaGrid += '<div class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' active">';
  //   diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" title="'+translations.titleRemoveCompareDiamonds+'" onclick="event.stopPropagation();removeCompare(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
  //   diaGrid += '</div>';
  // }
  // if(dia_img != 'None'){
  //   diaGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+diamondData.diamondId+'" data-img="'+dia_img+'" data-id="'+diamondData.diamondId+'" onclick="createDiamondProduct(this,`'+diamond_type+'`);">';
  // }else{
  //   diaGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+diamondData.diamondId+'" data-img="'+diamondStockImage[0]+'" data-id="'+diamondData.diamondId+'" onclick="createDiamondProduct(this,`'+diamond_type+'`);">';
  // }
  
  // diaGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+diamondData.diamondId+'" onClick="addRemoveProductToWishlist(`'+diamondData.diamondId+'`,`product`)">';
  // diaGrid += '<button class="love-button" gropulse-lbw-product-id="'+diamondData.diamondId+'">';
  // diaGrid += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#13177a" class="bi bi-heart" viewBox="0 0 16 16" id="IconChangeColor">';
  // if(jQuery.inArray(diamondData.diamondId.toString(),wishlistProducts)==(-1)){
  //   diaGrid += '<path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.920 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  // }else{
  //   diaGrid += '<path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  // }
  // diaGrid += '</svg></button>';  
  // diaGrid += '</div>'; 
  
  diaGrid += '</div>';
  diaGrid += '</div>';

  // if(diamondData.diamondVideo != 'None' && diamondData.diamondVideo != ''){
  //   diaGrid += '<div class="tps-diamondlist-item-360-video-icon-span">';
  //   if (jQuery(window).width() < 1199) { 
  //     diaGrid += '<span class="tps-diamondlist-item-video-icon" onClick="event.stopPropagation();show360VideoMobile(`'+diamondData.diamondId+'`)">video</span>';
  //   }else{
  //     diaGrid += '<span class="tps-diamondlist-item-video-icon">video</span>';
  //   }
  //   diaGrid += '</div>';
  // }
  
  diaGrid += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">';
  diaGrid += '<div class="tps-diamondlist-item-media-div">';
  diaGrid += getDiamondImageLayout(diamondData,diamond_title);
  if(diamondData.diamondVideo != 'None' && diamondData.diamondVideo != ''){
    diaGrid += '<span class="tps-diamondlist-media-loader" style="display: none;"></span>';
    // diaGrid += '<span class="tps-diamondlist-item-video-icon" onClick="event.stopPropagation();show360VideoMobile(`'+diamondData.diamondId+'`)">video</span>';
    diaGrid += '<div class="tps-diamondlist-video-iframe-div tps-embed-media-container" style="opacity: 0;">';
    //diaGrid += '<div class="tps-video-overlay"></div>'; 
    diaGrid += '</div>';
  }
  diaGrid += '</div>';
  diaGrid += '<div class="tps-diamondlist-result-grid-view-cn">'; 
  diaGrid += '<div class="tps-diamondlist-result-grid-title-price">';
  diaGrid += '<span class="tps-diamondlist-item-title">'+diamond_title+'</span>';
  diaGrid += '<div class="tps-diamond-item-price-section">';
  diaGrid += '<span class="tps-diamondlist-item-price">'+diamond_price+'</span>'; 
  if (compare_price != null && compare_price != undefined && compare_price != 0 && compare_price !== '') {
    diaGrid += '<div class="tps-compare-sec"><span class="tps-diamondlist-item-comp-price">'+compare_price+'</span><span class="tps-diamondlist-item-save-price"><label>Save</label> '+saving_price+'</span></div>';
  }
  diaGrid += '</div>';
  diaGrid += '</div>';
  diaGrid += '<div class="tps-diamondlist-item-meta-data">'; 
  diaGrid += getDiamondMetaInformation(diamondData);
  diaGrid += '</div>';   
  // diaGrid += '<div class="tps-diamondlist-item-view-diamond" style="display:none;>'; 
  // diaGrid += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" class="tps-diamondlist-item-detail-view-btn" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">'+translations.titleMoreInfo+'</a>';
  // diaGrid += '</div>';   
  diaGrid += '</div>';
  diaGrid += '</a>';

  if(diamonGridInfoShow == 'false'){
    //diamond info layout start
     diaGrid += '<div class="tps-diamondlist-item-info tps-diamond-info-'+diamondData.diamondId+'" style="display:none;">';
     diaGrid += '<span class="tps-diamondlist-item-info-close tps-diamond-info-close" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`grid`,`close`,event);">close</span>';
     diaGrid += getDiamondInformationLayout(diamondData);
     diaGrid += '</div>';
    //end
  }
  diaGrid += '<input type="hidden" id="tps_diamond_video_'+diamondData.diamondId+'" value="'+diamondData.diamondVideo+'">';
  diaGrid += '</div>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 diamonds
  }
  if(diamond_index == banner_display_count){
      var bannerHtml = $('#tps_banner_blog_'+page_no).html();
      if(bannerHtml != '' && bannerHtml != undefined){
        diaGrid += '<li class="tps-diamondlist-banner-section">';
        diaGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        diaGrid += '</li>';
      }
  }  
  //banner end
  
  return diaGrid;
}
/*** End ***/

/*** Diamonds Image Layout Start ***/
function getDiamondImageLayout(diamondData,diamond_title) { 
  // var session_variable = jQuery('#session_variable').val();
  var diamond_image = diamondData.diamondImage;
  var image = '';
  var diamondStockImage = [];
  // console.log(diamondImageUrl);
  // if(diamond_image == 'None' || diamond_image == undefined || diamond_image == ''){
      //get diamond stock image url
      $.each(diamondImageUrl, function(i, diamondImage) {   
        if(diamondData.diamondType == 'lab-white'){
          var imageParam = diamondData.shape.toLowerCase()+'_generic';
        }else if(diamondData.diamondType == 'lab-fancy'){
          if(diamondData.fancyColor == 'Brown') {
            var imageParam = diamondData.shape.toLowerCase()+'_generic';
          }else{
            var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
          }
        }     
               
        if(diamondImage.includes(imageParam)){    
          diamondStockImage.push(diamondImage);
        }
      });
  // }
  
  if(diamond_image != '' && diamond_image != 'NA' && diamond_image != 'N/A' && diamond_image != 'None' && diamond_image != 'undefined' ){
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="'+diamondStockImage[0]+'" alt="'+diamond_title+'" title="'+diamond_title+'" data-src="'+diamond_image+'" src="'+diamond_image+'" width="300" height="300">';
  }else{   
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="'+diamondStockImage[0]+'" alt="'+diamond_title+'" title="'+diamond_title+'" data-src="'+diamondStockImage[0]+'" src="'+diamondStockImage[0]+'" width="300" height="300">'; 
  }
  return image;
}
/*** Diamonds Layout Start ***/

/*** Call Us Button Click Start ***/
$(document).on(
    'click',
    'p.ring-to-us a, .ProductCustomerCare-ButtonWrapper a, .ProductCustomerCare-ButtonWrapper button',
    function (e) {
        e.preventDefault();

        $('#helpDrawer').addClass('active');
        $('.drawers-overlay').addClass('active');
        $('body').css('overflow', 'hidden');
    }
);
/*** Call Us Button Click End ***/

/*** Sticky Gallery On Scroll Start ***/
document.addEventListener("DOMContentLoaded", function () {
    const gallery = document.querySelector(".tps-diamond-gallery-grid-view");
    const stopSection = document.querySelector(".SparkleElegantPage-BottomMarquee.Marquee-Wrapper");

    if (!gallery || !stopSection) return;

    function toggleStickyGallery() {
        const stopSectionTop = stopSection.getBoundingClientRect().top;

        // Add sticky class while the stop section hasn't reached the viewport
        if (window.scrollY > 100 && stopSectionTop > 0) {
            gallery.classList.add("tps-sticky-gallery");
        } else {
            gallery.classList.remove("tps-sticky-gallery");
        }
    }

    window.addEventListener("scroll", toggleStickyGallery);
    toggleStickyGallery();
});
/*** Sticky Gallery On Scroll End ***/

function callInstallmentEstimator(container, price) {
  if (typeof InstallmentEstimator === 'undefined') {
    // script not loaded yet — retry shortly
    setTimeout(function () { callInstallmentEstimator(container, price); }, 100);
    return;
  }
  InstallmentEstimator.renderBanner(container, price);
}

function renderShopPayInstallmentBanner(priceInCents) {
  // Load Shopify's payment-terms component script once
  if (!document.querySelector('script[data-shop-pay-installments]')) {
    var s = document.createElement('script');
    s.src = "https://cdn.shopify.com/shopifycloud/shop-js/modules/v2/loader.payment-terms.esm.js"; // verify exact filename in your theme's product-page source
    s.type = "module";
    s.setAttribute('data-shop-pay-installments', 'true');
    document.head.appendChild(s);
  }

  var priceStr = (priceInCents / 100).toFixed(2);
  var el = document.createElement('shopify-payment-terms');
  el.setAttribute('shopify-meta', JSON.stringify({
    type: "product",
    variants: [{ id: 0, price: priceStr, eligible: true, available_loan_types: ["split_pay"] }],
    min_price: priceStr,
    max_price: priceStr,
    number_of_payment_terms: 4,
    available_loan_types: ["split_pay"]
  }));

  // document.getElementById('tps_shop_pay_installment_banner').innerHTML = '';
  // document.getElementById('tps_shop_pay_installment_banner').appendChild(el);
}